import { CheckOutlineSolid } from "@faire/slate-icons/CheckOutlineSolid";
import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  isVisible: boolean | undefined;
};

export const ProgressBarIcon: React.FC<IProps> = ({
  isVisible,
  className,
  ...props
}) => (
  <div {...props} className={containerStyle.cls({ visible: isVisible })}>
    <CheckOutlineSolid
      color="inherit"
      fontSize="inherit"
      titleAccess={undefined}
    />
  </div>
);

const containerStyle = tsv({
  variants: {
    visible: {
      true: "fs-progress-bar__icon--visible",
    },
  },
  base: "fs-progress-bar__icon",
});
